/* Timbrica — /airport-weather: состояние, поиск, адрес страницы.
 *
 * ⚠️ ДВА СЛОЯ ОТВЕТА, И ПОРЯДОК ВАЖЕН. Сверху — человеческий вывод: какая
 * сейчас категория условий, чем это грозит рейсу и почему. Ниже, СВЁРНУТЫМ, —
 * разбор сводки токен за токеном для тех, кому нужен именно METAR. Перевернуть
 * эти слои значит сделать тул, который пассажир закроет на второй секунде, а
 * таких декодеров в сети и так довольно.
 *
 * ⚠️ ВОЗРАСТ СВОДКИ ПОКАЗЫВАЕТСЯ ВСЕГДА. Метеослужбы выпускают METAR каждые
 * полчаса, но в глухих аэропортах — раз в несколько часов. Трёхчасовая сводка,
 * поданная как «сейчас», это выдумка, а не задержка данных.
 *
 * ⚠️⚠️ АЭРОПОРТ ЖИВЁТ В АДРЕСЕ СТРАНИЦЫ (?a=SVO). Без этого ссылку нельзя
 * послать («смотри, что в Стамбуле»), нельзя положить в закладки и нельзя
 * вернуться кнопкой «назад». Замер Wordstat показывает, что этого же ждут и от
 * поиска: «metar uuee» — 450 показов в месяц, «metar ulli» — 328, «uwgg metar»
 * — 280, то есть код аэропорта ВНУТРИ запроса. Страница без адреса на такой
 * запрос ответить не может в принципе.
 */

import * as AP from './airports.js';
import * as V from './render.js';
import { parseTaf } from './taf.js';

const CFG = window.AIRPORT_WX_CFG || {};
const $ = (id) => document.getElementById(id);
const ae = (ev, p) => { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
const stage = (n) => { try { window.__stage && window.__stage(n); } catch (e) {} };
const toast = (m, k) => { try { window.__toast && window.__toast(m, k || 'info'); } catch (e) {} };

V.setTranslations(CFG.t || {});
const tr = V.tr;
const esc = V.esc;

/* ── Состояние ───────────────────────────────────────────────────────────── */

const state = {
  slots: [],        // [{ role:'from'|'to', airport, data, taf, error }]
  focus: 0,
  panel: null,      // какая подробность раскрыта
  history: {},      // icao → массив наблюдений (ленивая догрузка)
  // ⚠️ Недельный прогноз догружается ОТДЕЛЬНО и ПОСЛЕ ответа: он от другого
  // источника, и его молчание не должно задерживать вердикт (см. контроллер).
  outlook: {},      // icao → массив дней или [] (источник ответил пусто)
  // ⚠️⚠️ ВТОРОЙ АЭРОПОРТ ДОБАВЛЯЕТСЯ ТОЛЬКО ПО ЯВНОЙ ПРОСЬБЕ. Первая версия
  // просто дописывала каждый следующий выбор вторым слотом — и тогда обычный
  // повторный поиск («а что в Стамбуле?») молча превращал экран в режим
  // маршрута, которого человек не просил, а первый аэропорт оставался висеть
  // рядом. Поиск ЗАМЕНЯЕТ то, что открыто; маршрут — отдельное действие с
  // отдельной кнопкой. Поймано сквозным прогоном в браузере.
  pendingAdd: false,
  // ⚠️ Вставленная сводка — ТО ЖЕ ПОЛЕ, что и поиск аэропорта, поэтому она и
  // живёт в общем состоянии, а не в своей карточке со своей кнопкой.
  pasted: null,      // сырая строка METAR/TAF, вставленная в поле поиска
  watches: [],       // слежки этого пользователя (Премиум)
  watchOpen: false,
};

const MAX_RECENT = 6;
const settings = {
  get(k, d) { try { return window.__toolSettings.load('airport-weather', k, d); } catch (e) { return d; } },
  set(k, v) { try { window.__toolSettings.save('airport-weather', k, v); } catch (e) {} },
};

/* ── Адрес страницы ──────────────────────────────────────────────────────── */

function codesFromUrl() {
  const p = new URLSearchParams(location.search);
  const raw = (p.get('a') || p.get('icao') || '').toUpperCase();
  return raw.split(/[,\-–]/).map((s) => s.trim()).filter(Boolean).slice(0, 2);
}

function syncUrl(replace) {
  const codes = state.slots.map((s) => s.airport.iata || s.airport.icao);
  const u = new URL(location.href);
  // ⚠️ Дефис, а не запятая: URLSearchParams кодирует запятую в «%2C», и
  // присланная ссылка читается как «?a=SVO%2CLED». Разбор принимает оба.
  if (codes.length) u.searchParams.set('a', codes.join('-'));
  else u.searchParams.delete('a');
  u.searchParams.delete('icao');
  try {
    history[replace ? 'replaceState' : 'pushState']({ a: codes.join(',') }, '', u.toString());
  } catch (e) {}
}

/* ── Недавние ────────────────────────────────────────────────────────────── */

function recent() {
  const v = settings.get('recent', []);
  return Array.isArray(v) ? v.filter((x) => typeof x === 'string').slice(0, MAX_RECENT) : [];
}

function remember(icao) {
  const list = recent().filter((x) => x !== icao);
  list.unshift(icao);
  settings.set('recent', list.slice(0, MAX_RECENT));
  renderRecent();
}

function renderRecent() {
  const box = $('aw-recent');
  if (!box) return;
  const list = recent();
  if (!list.length || !AP.ready()) { box.hidden = true; return; }
  const html = list.map((c) => {
    const a = AP.byCode(c);
    if (!a) return '';
    return '<button type="button" class="aw-chip" data-jump="' + esc(a.icao) + '">'
      + esc(AP.label(a)) + '</button>';
  }).filter(Boolean).join('');
  if (!html) { box.hidden = true; return; }
  box.innerHTML = '<span class="aw-recent-t">' + esc(tr('recent_title')) + '</span>' + html;
  box.hidden = false;
}

/* ── Поиск ───────────────────────────────────────────────────────────────── */

function mountPicker() {
  const input = $('aw-q');
  const list = $('aw-list');
  const nores = $('aw-nores');
  if (!input || !list) return;

  let items = [];
  let active = -1;
  let lastQuery = '';
  const basePlaceholder = input.placeholder;

  const close = () => { list.hidden = true; active = -1; input.setAttribute('aria-expanded', 'false'); };
  const hideNo = () => { if (nores) nores.hidden = true; };

  const render = () => {
    list.innerHTML = items.map((a, i) =>
      '<li class="aw-opt' + (i === active ? ' is-active" aria-selected="true' : '') + '"'
      + ' role="option" id="aw-opt-' + i + '" data-i="' + i + '">'
      + '<span class="aw-opt-code">' + esc(a.iata || a.icao) + '</span>'
      + '<span class="aw-opt-main">' + esc(AP.label(a)) + '</span>'
      + '<span class="aw-opt-cc">' + esc(a.cc || '') + '</span></li>').join('');
    list.hidden = items.length === 0;
    input.setAttribute('aria-expanded', items.length ? 'true' : 'false');
    input.setAttribute('aria-activedescendant', active >= 0 ? 'aw-opt-' + active : '');
  };

  /**
   * ⚠️ Тупик «ничего не найдено» — половина ответа. Человек ошибся в одной
   * букве, правильный ответ у нас есть, а страница молчит и отправляет его в
   * поисковик. Поэтому: похожие по написанию + прямая дверь «добавить
   * аэропорт», если его действительно нет.
   */
  const showNoMatch = (q) => {
    if (!nores) return;
    const near = AP.suggest(q, 4);
    let html = '<div class="aw-nm-t">' + esc(V.tr('no_match_title')) + '</div>';
    if (near.length) {
      html += '<div class="aw-nm-b">' + esc(tr('no_match_suggest')) + '</div><div class="aw-nm-l">'
        + near.map((a) => '<button type="button" class="aw-chip" data-jump="' + esc(a.icao) + '">'
          + esc(AP.label(a)) + '</button>').join('') + '</div>';
    } else {
      html += '<div class="aw-nm-b">' + esc(tr('no_match_body')) + '</div>';
    }
    // ⚠️ Ведём к ОБЩЕЙ форме заявки на странице (<x-tool-request>), а не к своей
    // ссылке: заявка попадает в ту же очередь /pino/suggestions, что и у
    // остальных тулов, и вторая дверь в ту же комнату не заводится.
    if (CFG.requestAnchor) {
      html += '<a class="aw-nm-link" href="' + esc(CFG.requestAnchor) + '" data-req-link>'
        + esc(tr('no_match_add')) + '</a>';
    }
    nores.innerHTML = html;
    nores.hidden = false;
    ae('aw_no_match', { q: q.slice(0, 40), near: near.length });
  };

  const pick = (a) => {
    if (!a) return;
    input.value = '';
    // Подсказка «аэропорт прилёта» держится ровно до выбора и возвращается.
    input.placeholder = basePlaceholder;
    close(); hideNo();
    ae('aw_pick', { icao: a.icao, q: lastQuery.slice(0, 40), add: state.pendingAdd ? 1 : 0 });
    if (state.pendingAdd && state.slots.length === 1) {
      state.pendingAdd = false;
      addAirport(a);
    } else if (state.slots.length) {
      replaceAirport(state.focus, a);
    } else {
      addAirport(a);
    }
  };

  const runSearch = () => {
    const q = input.value.trim();
    lastQuery = q;
    /* ⚠️⚠️ ОДНО ПОЛЕ НА ДВА ВИДА ВВОДА. Раньше вставка сводки жила в отдельной
       карточке за кнопкой «У меня есть готовая сводка», то есть человек со
       строкой на руках должен был сперва догадаться, что она вообще где-то
       принимается. Сводку узнать легко и без него: у неё есть группа времени
       «060200Z» либо она начинается словом METAR/SPECI/TAF. Названий городов
       такой формы не бывает, поэтому обычный поиск от этого не страдает. */
    if (looksLikeReport(q)) {
      items = []; render(); hideNo();
      if (state.pasted !== q) { state.pasted = q; paint(); ae('aw_paste_decode', { len: q.length }); }
      return;
    }
    if (state.pasted) { state.pasted = null; paint(); }
    if (q.length < 2) { items = []; render(); hideNo(); return; }
    items = AP.search(q, 8);
    active = items.length ? 0 : -1;
    render();
    if (items.length) hideNo(); else showNoMatch(q);
  };

  input.addEventListener('input', () => {
    AP.load(CFG).then(runSearch, () => toast(tr('airports_failed'), 'error'));
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (looksLikeReport(input.value.trim())) return;
      // ⚠️ Enter БЕЗ стрелок обязан выбирать первый вариант. Требовать
      // «сначала стрелкой вниз» — это правило, которого никто не знает; ровно
      // так строка поиска и выглядела бы неработающей.
      if (items.length) pick(items[active >= 0 ? active : 0]);
      else if (input.value.trim().length >= 2) {
        AP.load(CFG).then(() => { runSearch(); if (items.length) pick(items[0]); });
      }
      return;
    }
    if (list.hidden) return;
    if (e.key === 'ArrowDown') { active = Math.min(active + 1, items.length - 1); render(); e.preventDefault(); }
    else if (e.key === 'ArrowUp') { active = Math.max(active - 1, 0); render(); e.preventDefault(); }
    else if (e.key === 'Escape') { close(); }
  });

  list.addEventListener('mousedown', (e) => {
    const li = e.target.closest('[data-i]');
    if (!li) return;
    e.preventDefault();
    pick(items[+li.dataset.i]);
  });

  // ⚠️ Закрытие по blur с задержкой: без неё нажатие на пункт списка приходит
  // уже после того, как список исчез, и выбор мышью не работает вовсе.
  input.addEventListener('blur', () => setTimeout(close, 140));
  input.addEventListener('focus', () => { AP.load(CFG).catch(() => {}); }, { once: true });

  const go = $('aw-go');
  if (go) {
    go.addEventListener('click', () => {
      AP.load(CFG).then(() => {
        runSearch();
        if (looksLikeReport(input.value.trim())) return;
        if (items.length) pick(items[0]);
        else if (input.value.trim().length >= 2) showNoMatch(input.value.trim());
        else input.focus();
      });
    });
  }
}

/**
 * Похоже ли введённое на сырую сводку.
 *
 * ⚠️ Группа «ддччммZ» — самый надёжный признак: она обязательна и в METAR, и в
 * TAF, и её ни в одном названии аэропорта не встретить. Слово METAR/SPECI/TAF в
 * начале ловит случай, когда строку скопировали без группы времени.
 */
function looksLikeReport(v) {
  const t = String(v || '').trim();
  if (t.length < 12) return false;
  return /^(?:METAR|SPECI|TAF)\b/i.test(t) || /\b\d{6}Z\b/.test(t);
}

/* ── Загрузка сводки ─────────────────────────────────────────────────────── */

async function fetchWeather(icao) {
  const r = await fetch(CFG.api + '?icao=' + encodeURIComponent(icao), { credentials: 'same-origin' });
  if (!r.ok) throw new Error('http ' + r.status);
  return r.json();
}

function addAirport(a, opts) {
  const o = opts || {};
  const slot = { role: state.slots.length === 0 ? 'from' : 'to', airport: a, data: null, error: null, taf: null };
  if (state.slots.length >= 2) state.slots.splice(1, 1);
  state.slots.push(slot);
  state.focus = state.slots.length - 1;
  remember(a.icao);
  if (!o.silent) syncUrl(!!o.replaceUrl);
  paint();
  load(slot);
}

function replaceAirport(index, a) {
  const slot = state.slots[index];
  if (!slot) return addAirport(a);
  slot.airport = a; slot.data = null; slot.error = null; slot.taf = null;
  state.focus = index;
  remember(a.icao);
  syncUrl(false);
  paint();
  load(slot);
}

async function load(slot) {
  stage('loading');
  try {
    const j = await fetchWeather(slot.airport.icao);
    slot.data = j;
    slot.taf = (j && j.taf && j.taf.rawTAF)
      ? parseTaf(j.taf.rawTAF, j.taf.issueTime ? Date.parse(j.taf.issueTime) / 1000 : (j.fetched_at || null))
      : null;
    if (j && j.stale) ae('aw_served_stale', { icao: slot.airport.icao });
    loadOutlook(slot.airport.icao);
    ae('aw_loaded', {
      icao: slot.airport.icao,
      cat: (j && j.metar && j.metar.fltCat) || null,
      taf: slot.taf ? 1 : 0,
      rw: (j && j.runways && j.runways.length) || 0,
      near: (j && j.nearby && j.nearby.length) || 0,
      route: state.slots.length,
    });
    stage('loaded');
  } catch (e) {
    slot.error = tr('load_failed');
    ae('aw_load_failed', { icao: slot.airport.icao });
  }
  paint();
}

/**
 * Недельный прогноз — тихая догрузка.
 *
 * ⚠️ Отказ ничего не рисует и ничего не говорит: блок необязательный, и
 * сообщение «не удалось загрузить недельный прогноз» под уже полученным
 * ответом только пугает. Провал виден нам в телеметрии, а не человеку.
 */
function loadOutlook(icao) {
  if (state.outlook[icao] !== undefined) return;
  state.outlook[icao] = null;
  fetch(CFG.outlookApi + '?icao=' + encodeURIComponent(icao), { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .then((j) => {
      const days = (j && Array.isArray(j.days)) ? j.days : [];
      state.outlook[icao] = days;
      ae('aw_outlook', { icao, n: days.length });
      if (days.length && state.slots.some((s) => s.airport.icao === icao)) paint();
    })
    .catch(() => { state.outlook[icao] = []; });
}

/* ── Отрисовка ───────────────────────────────────────────────────────────── */

function paint() {
  const out = $('aw-result');
  if (!out) return;

  if (state.pasted) {
    // Код станции внутри строки узнаётся из нашего же справочника: тогда рядом
    // с разбором можно назвать аэропорт и предложить открыть его живую сводку.
    const code = (state.pasted.match(/\b([A-Z]{4})\b/) || [])[1];
    const ap = code ? AP.byCode(code) : null;
    out.innerHTML = V.pastedReport(state.pasted, ap);
    return;
  }
  if (!state.slots.length) {
    out.innerHTML = '<div class="aw-empty">' + esc(tr('result_empty')) + '</div>';
    return;
  }

  const route = state.slots.length > 1;
  const parts = [];

  parts.push('<div class="aw-cards' + (route ? ' is-route' : '') + '">');
  state.slots.forEach((s, i) => parts.push(V.airportCard(s, route && i === state.focus, route)));
  parts.push('</div>');

  parts.push('<div class="aw-bar">');
  if (!route) {
    parts.push('<button type="button" class="aw-act" data-act="add">' + esc(tr('add_dest')) + '</button>');
  } else {
    parts.push('<button type="button" class="aw-act" data-act="drop">' + esc(tr('drop_dest')) + '</button>');
  }
  parts.push('<button type="button" class="aw-act" data-act="refresh">' + esc(tr('refresh')) + '</button>');
  parts.push('<button type="button" class="aw-act" data-act="share">' + esc(tr('share')) + '</button>');
  parts.push(watchButton());
  parts.push('</div>');
  parts.push(watchPanel());

  const focus = state.slots[state.focus] || state.slots[0];

  if (focus && focus.taf) parts.push(V.forecastBand(focus.taf, focus.airport.tz));

  /* Недельный прогноз стоит ПОСЛЕ полосы TAF, а не вместо неё: до конца TAF
     официальный прогноз точнее модели, и подменять его было бы ухудшением. */
  if (focus) {
    const o = state.outlook[focus.airport.icao];
    if (o && o.length) parts.push(V.outlookStrip(o, CFG.locale));
  }

  if (focus && focus.data && focus.data.metar) {
    parts.push(details(focus, route));
  }

  parts.push('<p class="aw-src">' + esc(tr('source')) + '</p>');
  out.innerHTML = parts.join('');
}

const PANELS = ['decode', 'taf', 'trend', 'runways'];

function details(slot, route) {
  const open = state.panel;
  const tabs = PANELS.map((p) => {
    if (p === 'taf' && !slot.taf) return '';
    if (p === 'runways' && !(slot.data.runways && slot.data.runways.length)) return '';
    return '<button type="button" role="tab" class="aw-tab' + (open === p ? ' is-open' : '') + '"'
      + ' aria-selected="' + (open === p ? 'true' : 'false') + '" aria-controls="aw-panel"'
      + ' data-panel="' + p + '">' + esc(tr('tab_' + p)) + '</button>';
  }).filter(Boolean).join('');

  let body = '';
  if (open === 'decode') {
    body = '<p class="aw-note">' + esc(tr('decode_note')) + '</p>'
      + '<div class="aw-toks">' + V.tokensHtml(slot.data.metar.rawOb) + '</div>';
  } else if (open === 'taf' && slot.taf) {
    body = '<p class="aw-note">' + esc(tr('taf_note')) + '</p>'
      + '<div class="aw-toks">' + V.tokensHtml(slot.data.taf.rawTAF) + '</div>';
  } else if (open === 'trend') {
    const h = state.history[slot.airport.icao];
    body = h === undefined
      ? '<p class="aw-note">' + esc(tr('trend_loading')) + '</p>'
      : V.trendChart(h, slot.airport.tz);
  } else if (open === 'runways') {
    body = V.runwaysPanel(slot.data, slot.data.metar);
  }

  return '<section class="aw-det">'
    + '<div class="aw-tabs" role="tablist">' + tabs
    + (open ? '<button type="button" class="aw-tab aw-tab-x" data-panel="">' + esc(tr('collapse')) + '</button>' : '')
    + '</div>'
    + (open ? '<div class="aw-panel" id="aw-panel" role="tabpanel">' + body + '</div>' : '')
    + (route ? '<p class="aw-note is-small">' + esc(tr('details_of')) + ' ' + esc(AP.label(slot.airport)) + '</p>' : '')
    + '</section>';
}

/* ── Слежка за аэропортом (Премиум) ──────────────────────────────────────── */

/**
 * ⚠️⚠️ ЗА ЧТО ЗДЕСЬ ПРЕДЛАГАЕТСЯ ПЛАТИТЬ. Сам тул справочный и без капа:
 * смотреть погоду можно сколько угодно и бесплатно. Платное — ровно то, чего
 * просмотр дать не может: человек с рейсом в 06:20 не откроет страницу в три
 * ночи, ему нужно, чтобы его разбудили, если к утру лёг туман.
 *
 * ⚠️ Кнопка видна ВСЕМ, включая гостей: перк, которого не видно, ничего не
 * продаёт. Отказ приходит с сервера отдельным кодом, и по нему рисуется
 * предложение Премиума, а не безликий тост.
 */
function watchOf(icao) {
  return state.watches.find((w) => w.icao === icao) || null;
}

function watchButton() {
  const slot = state.slots[state.focus];
  if (!slot || !slot.data || !slot.data.metar) return '';
  const w = watchOf(slot.airport.icao);
  return '<button type="button" class="aw-act aw-act-watch' + (w ? ' is-on' : '') + '"'
    + ' data-act="watch" aria-expanded="' + (state.watchOpen ? 'true' : 'false') + '">'
    + (w ? '🔔 ' + esc(tr('watch_on')) : '🔔 ' + esc(tr('watch_cta'))) + '</button>';
}

function watchPanel() {
  if (!state.watchOpen) return '';
  const slot = state.slots[state.focus];
  if (!slot) return '';
  const w = watchOf(slot.airport.icao);

  const head = '<div class="aw-w-h">' + esc(tr('watch_title')) + '</div>'
    + '<p class="aw-note">' + esc(fill(tr('watch_body'), { place: AP.label(slot.airport) })) + '</p>';

  if (!CFG.auth) {
    return '<section class="aw-w">' + head
      + '<p class="aw-note is-small">' + esc(tr('watch_premium_note')) + '</p>'
      + '<div class="aw-w-row"><a class="aw-w-go" href="' + esc(CFG.loginUrl || '/login') + '">'
      + esc(tr('watch_login')) + '</a>'
      + '<a class="aw-act" href="' + esc(CFG.buyUrl || '/') + '">' + esc(tr('watch_learn')) + '</a></div></section>';
  }
  if (!CFG.pro) {
    return '<section class="aw-w">' + head
      + '<p class="aw-note is-small">' + esc(tr('watch_premium_note')) + '</p>'
      + '<div class="aw-w-row"><a class="aw-w-go" href="' + esc(CFG.buyUrl || '/') + '">'
      + esc(tr('watch_buy')) + '</a></div></section>';
  }

  const cat = w ? w.on_category : 'ifr';
  const haz = w ? !!w.on_hazard : true;
  const opts = ['ifr', 'lifr', 'off'].map((k) =>
    '<option value="' + k + '"' + (cat === k ? ' selected' : '') + '>' + esc(tr('watch_cat_' + k)) + '</option>').join('');

  return '<section class="aw-w">' + head
    + '<div class="aw-w-row">'
    + '<label class="aw-w-f"><span>' + esc(tr('watch_when')) + '</span>'
    + '<select class="lg-input" id="aw-w-cat">' + opts + '</select></label>'
    + '<label class="aw-w-c"><input type="checkbox" id="aw-w-haz"' + (haz ? ' checked' : '') + '> '
    + esc(tr('watch_hazard')) + '</label>'
    + '</div>'
    + '<div class="aw-w-row">'
    + '<button type="button" class="aw-w-go" data-act="watch-save">'
    + esc(tr(w ? 'watch_update' : 'watch_save')) + '</button>'
    + (w ? '<button type="button" class="aw-act" data-act="watch-del">' + esc(tr('watch_stop')) + '</button>' : '')
    + '</div>'
    + (w && w.until
      ? '<p class="aw-note is-small">' + esc(fill(tr('watch_until'), { date: untilText(w.until) })) + '</p>'
      : '<p class="aw-note is-small">' + esc(fill(tr('watch_days'), { n: String(CFG.watchDays || 14) })) + '</p>')
    + '<p class="aw-note is-small">' + esc(tr('watch_disclaimer')) + '</p>'
    + '</section>';
}

function untilText(iso) {
  try {
    return new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'long' }).format(new Date(iso));
  } catch (e) { return String(iso).slice(0, 10); }
}

const fill = (text, data) => {
  let s = String(text);
  for (const k of Object.keys(data || {})) s = s.split(':' + k).join(String(data[k]));
  return s;
};

async function loadWatches() {
  if (!CFG.auth || !CFG.watchApi) return;
  try {
    const r = await fetch(CFG.watchApi, { credentials: 'same-origin' });
    const j = await r.json();
    state.watches = Array.isArray(j.watches) ? j.watches : [];
  } catch (e) {
    state.watches = [];
  }
}

async function saveWatch() {
  const slot = state.slots[state.focus];
  if (!slot) return;
  const cat = ($('aw-w-cat') || {}).value || 'ifr';
  const haz = !!(($('aw-w-haz') || {}).checked);
  if (cat === 'off' && !haz) { toast(tr('watch_nothing'), 'warning'); return; }
  try {
    const r = await fetch(CFG.watchApi, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': (document.querySelector('meta[name=csrf-token]') || {}).content || '',
      },
      body: JSON.stringify({
        icao: slot.airport.icao, label: AP.label(slot.airport),
        on_category: cat, on_hazard: haz, days: CFG.watchDays || 14,
      }),
    });
    const j = await r.json();
    if (!r.ok) {
      // ⚠️ Отказ по тарифу — не ошибка, а предложение: рисуем его как
      // предложение, а не как красный тост «что-то пошло не так».
      if (j.error === 'premium_required') { CFG.pro = false; paint(); return; }
      if (j.error === 'watch_limit') { toast(fill(tr('watch_limit'), { n: String(j.max) }), 'warning'); return; }
      toast(tr('watch_failed'), 'error');
      return;
    }
    await loadWatches();
    toast(tr('watch_done'), 'success');
    ae('aw_watch_save', { icao: slot.airport.icao, cat: cat, haz: haz ? 1 : 0 });
    paint();
  } catch (e) {
    toast(tr('watch_failed'), 'error');
  }
}

async function deleteWatch() {
  const slot = state.slots[state.focus];
  const w = slot && watchOf(slot.airport.icao);
  if (!w) return;
  try {
    await fetch(CFG.watchApi + '/' + w.id, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': (document.querySelector('meta[name=csrf-token]') || {}).content || '',
      },
    });
    await loadWatches();
    ae('aw_watch_delete', { icao: slot.airport.icao });
    paint();
  } catch (e) {
    toast(tr('watch_failed'), 'error');
  }
}

/* ── Действия ────────────────────────────────────────────────────────────── */

function openPanel(p) {
  state.panel = p || null;
  settings.set('panel', state.panel);
  paint();
  if (p === 'trend') loadHistory();
  if (p) ae('aw_panel', { panel: p });
}

async function loadHistory() {
  const slot = state.slots[state.focus];
  if (!slot || state.history[slot.airport.icao] !== undefined) return;
  state.history[slot.airport.icao] = undefined;
  try {
    const r = await fetch(CFG.historyApi + '?icao=' + encodeURIComponent(slot.airport.icao),
      { credentials: 'same-origin' });
    const j = await r.json();
    state.history[slot.airport.icao] = Array.isArray(j.history) ? j.history : [];
    ae('aw_history', { icao: slot.airport.icao, n: state.history[slot.airport.icao].length });
  } catch (e) {
    state.history[slot.airport.icao] = [];
  }
  if (state.panel === 'trend') paint();
}

function share() {
  const url = location.href;
  const title = state.slots.map((s) => AP.label(s.airport)).join(' → ');
  if (navigator.share) {
    navigator.share({ title, url }).then(() => ae('aw_share', { via: 'native' })).catch(() => {});
    return;
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url)
      .then(() => { toast(tr('share_copied'), 'success'); ae('aw_share', { via: 'clipboard' }); })
      .catch(() => toast(url, 'info'));
    return;
  }
  toast(url, 'info');
}

/** Open an airport from outside the search box (a "did you mean" chip, the request form). */
function jumpTo(a) {
  state.pasted = null;
  const nores = $('aw-nores');
  if (nores) nores.hidden = true;
  const q = $('aw-q'); if (q) q.value = '';
  if (state.slots.length) replaceAirport(state.focus, a); else addAirport(a);
}

/* ⚠️ The "airport is missing" form is always on the page, so people file what
 * the search already has: queue triage 2026-10-15 — "BXK" (in the data, found
 * by code) and "Berlin" (BER is the first hit). The shared request form asks
 * this hook while the person types and offers the airports as chips; sending
 * stays available. Not loaded yet → no offers (and the load is started). */
function mountRequestDeflect() {
  window.__toolRequestDeflect = window.__toolRequestDeflect || {};
  window.__toolRequestDeflect['airport-weather'] = (text) => {
    if (!AP.ready()) { AP.load(CFG).catch(() => {}); return []; }
    return AP.search(text, 6).map((a) => ({
      label: (a.iata || a.icao) + ' · ' + AP.label(a),
      onPick: () => {
        jumpTo(a);
        const out = $('aw-result');
        if (out) out.scrollIntoView({ block: 'nearest' });
        ae('aw_request_deflect', { icao: a.icao });
      },
    }));
  };
}

function mountActions() {
  mountRequestDeflect();
  const root = $('awRoot');
  if (!root) return;

  // ⚠️ Ссылка «аэропорта нет» ведёт к форме заявки НИЖЕ на странице. Прыгать
  // туда якорем нельзя — глобальное правило запрещает уводить прокрутку; ставим
  // курсор в поле, а `block:'nearest'` подтянет его, только если оно за экраном.
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('[data-req-link]');
    if (!link) return;
    e.preventDefault();
    const ta = document.querySelector('[data-tool-request] [data-tr-input]');
    if (!ta) return;
    ta.scrollIntoView({ block: 'nearest' });
    ta.focus();
    ae('aw_request_open', {});
  });

  root.addEventListener('click', (e) => {
    const jump = e.target.closest('[data-jump]');
    if (jump) {
      const a = AP.byCode(jump.dataset.jump);
      if (a) {
        jumpTo(a);
        ae('aw_jump', { icao: a.icao });
      }
      return;
    }
    const tab = e.target.closest('[data-panel]');
    if (tab) {
      const p = tab.dataset.panel;
      openPanel(state.panel === p ? null : p);
      return;
    }
    const card = e.target.closest('.aw-ap');
    if (card && state.slots.length > 1) {
      const i = state.slots.findIndex((s) => s.airport.icao === card.dataset.icao);
      if (i >= 0 && i !== state.focus) {
        state.focus = i;
        if (state.panel === 'trend') loadHistory();
        paint();
        ae('aw_focus', { icao: card.dataset.icao });
      }
      return;
    }
    const act = e.target.closest('[data-act]');
    if (!act) return;
    if (act.dataset.act === 'paste-clear') {
      state.pasted = null;
      const q = $('aw-q'); if (q) { q.value = ''; q.focus(); }
      paint();
      return;
    }
    if (act.dataset.act === 'add') {
      state.pendingAdd = true;
      const q = $('aw-q');
      if (q) { q.focus(); q.placeholder = tr('search_placeholder_dest'); }
      ae('aw_add_dest_click', {});
    } else if (act.dataset.act === 'drop') {
      state.slots.splice(1, 1);
      state.focus = 0;
      state.pendingAdd = false;
      syncUrl(false);
      paint();
    } else if (act.dataset.act === 'refresh') {
      const slot = state.slots[state.focus];
      if (slot) { slot.data = null; slot.error = null; delete state.history[slot.airport.icao]; paint(); load(slot); }
      ae('aw_refresh', {});
    } else if (act.dataset.act === 'share') {
      share();
    } else if (act.dataset.act === 'watch') {
      state.watchOpen = !state.watchOpen;
      paint();
      if (state.watchOpen) ae('aw_watch_open', { pro: CFG.pro ? 1 : 0, auth: CFG.auth ? 1 : 0 });
    } else if (act.dataset.act === 'watch-save') {
      saveWatch();
    } else if (act.dataset.act === 'watch-del') {
      deleteWatch();
    }
  });

  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const card = e.target.closest && e.target.closest('.aw-ap');
    if (card && state.slots.length > 1) { e.preventDefault(); card.click(); }
  });
}

/* ── Старт ─────────────────────────────────────────────────────────────── */

async function boot() {
  mountPicker();
  mountActions();

  const saved = settings.get('panel', null);
  if (PANELS.indexOf(saved) !== -1) state.panel = saved;

  let codes = codesFromUrl();
  // ⚠️ Последний аэропорт восстанавливается ТОЛЬКО когда адрес пуст: ссылка,
  // которую человеку прислали, обязана открыть то, что в ней написано.
  if (!codes.length) {
    const last = recent()[0];
    if (last) codes = [last];
  }

  try {
    await AP.load(CFG);
  } catch (e) {
    const out = $('aw-result');
    if (out) out.innerHTML = '<div class="aw-empty is-bad">' + esc(tr('airports_failed')) + '</div>';
    stage('ready');
    return;
  }

  renderRecent();
  // Слежки грузятся параллельно и на отрисовку не влияют: их отсутствие
  // означает только, что кнопка нарисуется как «начать следить».
  loadWatches().then(() => { if (state.slots.length) paint(); });

  const found = codes.map(AP.byCode).filter(Boolean).slice(0, 2);
  if (found.length) {
    found.forEach((a, i) => {
      const slot = { role: i === 0 ? 'from' : 'to', airport: a, data: null, error: null, taf: null };
      state.slots.push(slot);
    });
    state.focus = 0;
    remember(found[0].icao);
    syncUrl(true);
    paint();
    state.slots.forEach(load);
    if (state.panel === 'trend') loadHistory();
  } else {
    paint();
  }

  window.addEventListener('popstate', () => {
    const c = codesFromUrl();
    const list = c.map(AP.byCode).filter(Boolean).slice(0, 2);
    state.slots = list.map((a, i) => ({ role: i === 0 ? 'from' : 'to', airport: a, data: null, error: null, taf: null }));
    state.focus = 0;
    paint();
    state.slots.forEach(load);
  });

  stage('ready');
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
